
import React, { useState, useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { RefreshCw } from "lucide-react";
import { useAuth } from '@/context/AuthContext';
import SystemStatusReport from './SystemStatusReport';
import SystemCheckCard, { SystemCheck } from './SystemCheckCard';
import StatusStatistics from './StatusStatistics';
import SystemChecksList from './SystemChecksList';
import PriorityTasksCard from './PriorityTasksCard';
import { SystemCheckService } from './SystemCheckService';

const ProjectStatusReport: React.FC = () => {
  const [checks, setChecks] = useState<SystemCheck[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { user, profile } = useAuth();

  const runSystemChecks = async () => {
    setIsLoading(true);
    try {
      const newChecks = await SystemCheckService.runSystemChecks(user, profile);
      setChecks(newChecks);
    } catch (error) {
      console.error('Error running system checks:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    runSystemChecks();
  }, [user, profile]);

  const successCount = checks.filter(check => check.status === 'success').length;
  const warningCount = checks.filter(check => check.status === 'warning').length;
  const errorCount = checks.filter(check => check.status === 'error').length;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold">Отчет о состоянии ARENDAPRO+</h2>
          <p className="text-muted-foreground">
            Комплексная проверка системы: {successCount} успешно, {warningCount} предупреждений, {errorCount} ошибок
          </p>
        </div>
        <Button onClick={runSystemChecks} disabled={isLoading}>
          <RefreshCw className={`mr-2 h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
          Обновить
        </Button>
      </div>

      <StatusStatistics checks={checks} />

      <Tabs defaultValue="status" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="status">Системные проверки</TabsTrigger>
          <TabsTrigger value="report">Функциональный отчет</TabsTrigger>
        </TabsList>
        
        <TabsContent value="status" className="space-y-6">
          <SystemChecksList checks={checks} />
          <PriorityTasksCard />
        </TabsContent>
        
        <TabsContent value="report">
          <SystemStatusReport />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ProjectStatusReport;
